import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { noSpinnerHeader, noSpinnerTrueValue } from '../spinner/spinner.service';

@Injectable()
export class VideoAssetsService {
    private endpoint = 'video-assets';

    constructor(private http: HttpClient) {
    }

    async incrementPlayCount(assetId: string): Promise<void> {
        return this.http.put<void>(this.endpoint, { assetId: assetId, command: 'incrementPlayCount' }).toPromise();
    }

    async reject(assetId: string, reason: string): Promise<void> {
        return this.http.post<void>(this.endpoint, { assetId: assetId, reason: reason }, { headers: { [noSpinnerHeader]: noSpinnerTrueValue } }).toPromise();
    }

    async setHasBeenDownloaded(assetId: string): Promise<void> {
        return this.http.put<void>(this.endpoint, { assetId: assetId, command: 'setHasBeenDownloaded' }).toPromise();
    }
}
